const SkeletonData = {
    Reports: {
        columns: [
            '0-Attendance - September 23, 2021',
            '1-September 15, 2021',
            '2-HTML - Exercise',
            '3-HTML - Lab',
            '4-CSS 1 - Exercise',
            '5-CSS 1 - Lab',
            '6-CSS 2 - Exercise',
            '7-CSS 2 - Lab',
            '8-Intro to Programming - Exercise',
            '9-Intro to Programming - Lab',
            '10-Expressions and Statements - Lab',
            '11-Expressions and Statements - Exercise',
            '12-Expressions and Statements - Extra credit',
            '13-Conditional Statements - Extra credit',
            '14-Conditional Statements - Lab',
            '15-Conditional Statements - Exercise',
            '16-Conditional Statements Advanced - Lab',
            '17-Conditional Statements Advanced - Exercise',
            '18-For Loops - Extra credit',
            '19-For Loops - Lab',
            '20-For Loops - Exercise',
            '21-While Loops - Extra credit',
            '22-While Loops - Lab',
            '23-While Loops - Exercise',
            '24-Nested Loops - Extra credit',
            '25-Nested Loops - Exercise',
            '26-Nested Loops - Lab',
            '27-Exam Preparation Questions',
            '28-Exam',
            '29-MI6 React.js Project'
        ],
        rows: {
            'Quality Assurance': [
                '0-0',
                '1-1',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-92',
                '9-52',
                '10-50',
                '11-0',
                '12-0',
                '13-0',
                '14-100',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-50',
                '29-75.91'
            ],
            'Kim Benedict': [
                '0-1',
                '1-1',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-0',
                '9-100',
                '10-100',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-17',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-10',
                '29-90'
            ],
            'Neimark Junsay Braga': [
                '0-1',
                '1-0',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-50',
                '9-100',
                '10-0',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-10',
                '29-0'
            ],
            'Rave Arevalo': [
                '0-1',
                '1-1',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-25',
                '9-100',
                '10-0',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-80',
                '29-0'
            ],
            'Jechris Soldevilla': [
                '0-0',
                '1-0',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-0',
                '9-0',
                '10-0',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-0',
                '29-0'
            ],
            'Quality Assurance1': [
                '0-0',
                '1-1',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-92',
                '9-52',
                '10-50',
                '11-0',
                '12-0',
                '13-0',
                '14-100',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-50',
                '29-75.91'
            ],
            'Kim Benedict2': [
                '0-1',
                '1-1',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-0',
                '9-100',
                '10-100',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-17',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-10',
                '29-90'
            ],
            'Neimark Junsay Braga3': [
                '0-1',
                '1-0',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-50',
                '9-100',
                '10-0',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-10',
                '29-0'
            ],
            'Rave Arevalo4': [
                '0-1',
                '1-1',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-25',
                '9-100',
                '10-0',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-80',
                '29-0'
            ],
            'Jechris Soldevilla5': [
                '0-0',
                '1-0',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-0',
                '9-0',
                '10-0',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-0',
                '29-0'
            ],
            'Quality Assurance2': [
                '0-0',
                '1-1',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-92',
                '9-52',
                '10-50',
                '11-0',
                '12-0',
                '13-0',
                '14-100',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-50',
                '29-75.91'
            ],
            'Kim Benedict3': [
                '0-1',
                '1-1',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-0',
                '9-100',
                '10-100',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-17',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-10',
                '29-90'
            ],
            'Neimark Junsay Braga2': [
                '0-1',
                '1-0',
                '2-0',
                '3-0',
                '4-0',
                '5-0',
                '6-0',
                '7-0',
                '8-50',
                '9-100',
                '10-0',
                '11-0',
                '12-0',
                '13-0',
                '14-0',
                '15-0',
                '16-0',
                '17-0',
                '18-0',
                '19-0',
                '20-0',
                '21-0',
                '22-0',
                '23-0',
                '24-0',
                '25-0',
                '26-0',
                '27-0',
                '28-10',
                '29-0'
            ],
        },
    }
};

export default SkeletonData;